/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// import for excel download
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

// Material UI table
import { MaterialReactTable } from "material-react-table";

//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import BlogHeader from "../Header/BlogHeader";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
// import ViewBlogPopup from "../Popup/ViewBlogPopup";
import BlogFilterPopup from "../Popup/BlogFilterPopup";

//import images
import { assetImages } from "constants";

import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";

const BlogListBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation

  // showSkeleton = true  → show skeleton (initial load + filter apply/reset)
  // showSkeleton = false → no skeleton (search typing — table stays visible)
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);
  const [blogList, setBlogList] = useState([]);

  //filter requirements
  // ✅ CHANGED: null = popup hasn't decided yet (skip API call)
  // []    = no default filter, fetch all
  // [...] = has filters, fetch filtered
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  // global search
  const [globalSearch, setGlobalSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // Pagination -------------------------------------------
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10, //customize the default page size
  });

  // paginatin ends -----------------------------------
  const [reloadData, setReloadData] = useState(false); // reload data
  const [isFilterReset, setIsFilterReset] = useState(false); // filter reset
  const [showAllRecords, setShowAllRecords] = useState(false);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedBlogIds, setSelectedBlogIds] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Tag/label column related states
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedBlogId, setSelectedBlogId] = useState(null);

  //function for get all blogs
  const getAllBlogs = async (
    searchTerm = "",
    withSkeleton = false,
    showAllRecords = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_BLOG;

      if (showAllRecords) {
        requestUrl += `&showallrecords=${showAllRecords}`;
      }

      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("url of all blogs------->", requestUrl);

      const response = await getData(requestUrl);

      console.log("blog list response------>", response);

      if (response.status) {
        setMessageType("success");

        setBlogList(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  // function for get filtered blogs (copied crmopportunity filter API call logic)
  const getFilteredBlogList = async (
    searchTerm = "",
    withSkeleton = false,
    showAllRecords = false,
  ) => {
    try {
      if (withSkeleton) setShowSkeleton(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_FILTERED_BLOG;

      if (showAllRecords) {
        requestUrl += `&showallrecords=${showAllRecords}`;
      }

      if (searchTerm && searchTerm.trim() !== "") {
        requestUrl += `&search=${encodeURIComponent(searchTerm.trim())}`;
      }

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setBlogList(response.data);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      console.log(error.message);
      setMessageType("error");
      setAlertMessage(error.message);
    } finally {
      setShowSkeleton(false);
      setIsDataReady(true);
      setShowAlert(true);
    }
  };

  // Update the rank value in the blogList state array
  const rankInputChangeHandler = (row, value) => {
    const updatedBlogList = [...blogList];
    const rowIndex = updatedBlogList.findIndex(
      (blog) => blog._id === row.original._id,
    );
    if (rowIndex !== -1) {
      updatedBlogList[rowIndex].rank = value;
      setBlogList(updatedBlogList);
    }
  };

  //function for remove tag from blog
  const removeTagFromBlog = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_BLOG;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedBlogId(null);
      }, 1000);
    }
  };

  //function  for delete bulk blogs
  const deleteBulkBlogs = async () => {
    if (selectedBlogIds.length > 0) {
      try {
        const blogListToBeDeleted = blogList.filter((item) =>
          selectedBlogIds.includes(item._id),
        );

        let blogData = {
          bloglist: blogListToBeDeleted,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_BLOG;

        const response = await putData(requestURL, blogData);

        console.log("delete blog response------>", response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setBlogList((prevList) =>
              prevList.filter((item) => !selectedBlogIds.includes(item._id)),
            );
            setSelectedBlogIds([]);
            setRowSelection({});
          }, 500);
        } else {
          setMessageType("error");
        }
        setAlertMessage(response.message);
      } catch (error) {
        console.log(error.message);
        setMessageType("error");
        setAlertMessage(error.message);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one blog");
    }
    setShowAlert(true);
  };

  //function for update rank
  const updateRankHandler = async () => {
    if (selectedBlogIds.length > 0) {
      try {
        const blogListToBeUpdate = blogList.filter((item) =>
          selectedBlogIds.includes(item._id),
        );

        let blogData = {
          bloglist: blogListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_BLOG;

        const response = await putData(requestURL, blogData);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          setTimeout(() => {
            setSelectedBlogIds([]);
            setRowSelection({});
          }, 1000);
        } else {
          setMessageType("error");
        }
        setAlertMessage(response.message);
      } catch (error) {
        console.log(error.message);
        setMessageType("error");
        setAlertMessage(error.message);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select atleast one blog");
    }
    setShowAlert(true);
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setBlogList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  // Column visibility and order logic
  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Action"),
      enableColumnActions: false,
      enableColumnDragging: false,
      enableSorting: false,
      Cell: ({ row }) => (
        <Link
          className="action_btn_mui"
          to={`/admin/blog/save/${row.original._id}`}
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </Link>
      ),
    },
    {
      accessorKey: "name",
      header: t("Title"),
      size: 250,
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.taglist && row.original.taglist.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.taglist &&
                  row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator?.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedBlogId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromBlog([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedBlogId &&
                          selectedBlogId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedBlogIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "rank",
      header: t("Rank"),
      Cell: ({ renderedCellValue, row }) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            width: "100px",
          }}
        >
          <input
            // loading="lazy"
            type="number"
            name="rank"
            id="rank"
            value={row.original.rank}
            onChange={(e) => rankInputChangeHandler(row, e.target.value)}
            className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
          />
        </Box>
      ),
    },
    {
      accessorKey: "categorystring",
      header: t("Category"),
    },
    {
      accessorKey: "authorname",
      header: t("Posted By"),
      Cell: ({ row }) => (
        <div className="d-flex border-bottom-0">
          <div className="d-flex align-items-center gap-2">
            <div
              className="avatar rounded-circle overflow-hidden"
              style={{ width: "25px", height: "25px" }}
            >
              <img
                src={
                  row.original.authorimage == ""
                    ? assetImages.defaultUser
                    : url.SERVER_URL + row.original.authorimage
                }
                alt="admin"
                className="w-100 h-100 object-fit-cover object-center"
              />
            </div>
            <p>{row.original.authorname}</p>
          </div>
          <button
            onClick={() => {
              createContactChatHandler(
                row.original.author,
                "MOD_BLOG",
                row.original._id,
                row.original.name,
              );
            }}
            className={
              row.original.author?.toString() === userInfo._id.toString()
                ? "d-none"
                : "d-flex align-items-center ms-auto border-0 bg-light"
            }
          >
            <span className="d-block material-symbols-outlined icon-md text-primary">
              chat
            </span>
          </button>
        </div>
      ),
    },
    {
      accessorKey: "createddate",
      header: t("Date"),
    },
  ];

  //* Material React Table Column and States */
  const columns = useMemo(
    () => initialTableColumns,
    [blogList, i18n.language, selectedTagId],
  );

  /* Updates the column visibility state by toggling the visibility of the column with the given accessor key.*/
  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  /* Represents the state of column visibility in the table.*/
  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  //function for column visibility
  const onColumnVisiblityHandler = (newColumnState) => {
    if (typeof newColumnState === "function") {
      const newColumnStateName = newColumnState();
      setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
    } else {
      setVisibleColoumns(newColumnState);
    }
  };

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  //function for change column order
  const changeColumnOrderHandler = (changedOrder) => {
    setColumnOrder(changedOrder);
  };

  const resetFilterData = () => {
    setRowSelection({});
    setSelectedBlogIds([]);
    setJsonFilterQuery(null);
    setShowAllRecords(false);

    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });

    setIsFilterReset(true);
    setReloadData(true);
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  // reload happened — always show skeleton
  useEffect(() => {
    if (reloadData) {
      getAllBlogs("", true, false); // withSkeleton=true
      setReloadData(false);
    }
  }, [reloadData]);

  // CHANGED: Single API trigger — fires only after popup has decided.
  // null guard prevents API call before popup responds.
  // withSkeleton=true — filter apply always shows skeleton.
  useEffect(() => {
    if (jsonFilterQuery === null) return; // popup not ready yet, wait

    if (jsonFilterQuery?.length > 0) {
      getFilteredBlogList(debouncedSearch, true, false); // withSkeleton=true
    } else {
      getAllBlogs(debouncedSearch, true, false); // withSkeleton=true
    }
  }, [jsonFilterQuery]);

  // Search effect — no skeleton (table stays visible).
  // isDataReady guard prevents running before initial load finishes.
  // Priority: showAllRecords > jsonFilterQuery > default
  useEffect(() => {
    if (!isDataReady) return; // wait for initial load

    if (showAllRecords) {
      getAllBlogs(debouncedSearch, false, true); // showAllRecords + debounce search
    } else if (jsonFilterQuery?.length > 0) {
      getFilteredBlogList(debouncedSearch, false, false); // withSkeleton=false
    } else {
      getAllBlogs(debouncedSearch, false, false); // withSkeleton=false
    }
  }, [debouncedSearch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(globalSearch);
    }, 600);
    return () => clearTimeout(timer);
  }, [globalSearch]);

  useEffect(() => {
    //do something when the row selection changes...
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );

    if (selectedIdsArray.length > 0) {
      setSelectedBlogIds(selectedIdsArray);
    } else {
      setSelectedBlogIds([]);
    }
  }, [rowSelection]);

  const downloadAsExcel = () => {
    if (blogList.length > 0) {
      // Define headers for blogs
      const headers = [
        t("Title"),
        t("Label"),
        t("Category"),
        t("Posted By"),
        t("Date"),
      ];

      // Filter data based on selection
      const filteredList =
        selectedBlogIds.length > 0
          ? blogList.filter((item) => selectedBlogIds.includes(item._id))
          : blogList;

      // Map data to rows
      const data = filteredList.map((item) => [
        item.name || "",
        item.taglist && Array.isArray(item.taglist)
          ? item.taglist.map((tag) => tag.title).join(", ")
          : item.tagstring || "",
        item.categorystring || "",
        item.authorname || "",
        item.createddate || "",
      ]);

      // Create worksheet and workbook
      const ws = XLSX.utils.aoa_to_sheet([headers, ...data]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, t("Blogs"));

      // Write to buffer and save
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], { type: "application/octet-stream" });
      const fileName = `${t("Blogs")}_${new Date().toISOString().split("T")[0]}.xlsx`;
      FileSaver.saveAs(blob, fileName);
    }
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_CMS")
  ) {
    return (
      <div id="content_wrapper">
        <section className="blog-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            <BlogHeader
              reloadBlogList={refreshRecords}
              updateRankHandler={updateRankHandler}
              downloadAsExcel={downloadAsExcel}
              blogList={blogList}
              jsonFilterQuery={jsonFilterQuery ?? []}
              selectedBlogIds={selectedBlogIds}
              showAllOpportunities={() => {
                setJsonFilterQuery(null);
                getAllBlogs("");
                setShowAllRecords(true);
              }}
            />

            {/* ----- blog list table start ----- */}
            {!isDataReady || showSkeleton ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                {/* ------ pagination section end ------ */}
                <MaterialReactTable
                  columns={columns}
                  data={blogList}
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => `${row._id}`} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{
                    // ✅ If globalSearch exists, use value; otherwise undefined
                    globalFilter: globalSearch || undefined,
                    rowSelection,
                    pagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  initialState={{
                    rowSelection,
                    pagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination} // set pagination
                  autoResetPageIndex={false}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 200,
                    size: 50, //make columns wider by default
                  }}
                  enableColumnOrdering={true}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                  // ✅ typing → setGlobalSearch → debounce → setDebouncedSearch → API call
                  onGlobalFilterChange={(value) => setGlobalSearch(value ?? "")}
                />
              </div>
            )}
            {/* ----- blog list table end ----- */}
          </div>
        </section>
        {/* ======== all modal and pop up render here ======= */}
        <AddLabelModal
          moduleName="blog"
          selectedIds={selectedBlogIds}
          afterTagModalClose={afterModalActionClose}
          onModalClose={() => {
            setSelectedBlogIds([]);
            setRowSelection({});
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* blog search popup */}
        <BlogFilterPopup
          moduleSlug="bloglist"
          setJsonFilterQuery={setJsonFilterQuery}
          reloadList={refreshRecords}
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
          setColumnOrder={setColumnOrder}
          setVisibleColoumns={setVisibleColoumns}
          columnOrder={columnOrder}
          visibleColoumns={visibleColoumns}
          columns={columns}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setRowSelection({});
            setSelectedBlogIds([]);
          }}
          onDelete={deleteBulkBlogs}
          moduleName={t("blog")}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default BlogListBody;
